import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TResourceDM from './TResourceDM'
import TTextDM from './TTextDM'
import TJobCardDM from './TJobCardDM'
import TContractCodeDocumentDM from './TContractCodeDocumentDM'

/**
 * Production calendars items
 */
export default class TJobCardScheduleQueueDM extends Data {
	public static className = 'TJobCardScheduleQueueDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Průvodka
	 */
	JobCardBindRID?: number

	/**
	 * Člen
	 */
	Member?: string

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Rozvrženo
	 */
	IsManuallyAdjustedSchedule?: string

	/**
	 * Trvání
	 */
	Duration?: number

	/**
	 * Množství
	 */
	Quantity?: number

	/**
	 * Pracoviště
	 */
	WorkPlaceRID?: number

	/**
	 * Kalendář
	 */
	CalendarId?: number

	/**
	 * Archivováno
	 */
	IsArchived?: string

	/**
	 * Popis
	 */
	Description?: string

	/**
	 * Datum směny
	 */
	WorkshiftDate?: Date

	/**
	 * Směna
	 */
	WorkshiftRID?: number

	/**
	 * Čas od
	 */
	TimeFrom?: Date

	/**
	 * Datum
	 */
	Date?: Date

	/**
	 * Zdroj průvodky
	 */
	JobCardResourceRID?: number

	/**
	 * Operace průvodky
	 */
	JobCardOperationRID?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Doklad
	 */
	DocumentCalc?: string

	/**
	 * Datum od
	 */
	DateFromCalc?: Date

	/**
	 * Datum do
	 */
	DateToCalc?: Date

	/**
	 * Trvání
	 */
	DurationCalc?: number

	/**
	 * Trvání (jedn.)
	 */
	DurationUMCalc?: number

	/**
	 * Kód
	 */
	OperationCodeCalc?: string

	/**
	 * Čas do
	 */
	PlannedTimeToCalc?: Date

	/**
	 * undefined
	 */
	MemberNumberCalc?: number

	/**
	 * Zdroj
	 */
	@Type(() => TResourceDM)
	ResourceId?: TResourceDM

	/**
	 * Čas operace
	 */
	@Type(() => TTextDM)
	OperationTime?: TTextDM

	/**
	 * Průvodka
	 */
	@Type(() => TJobCardDM)
	JobCardRID?: TJobCardDM

	/**
	 * Kód zakázky
	 */
	@Type(() => TContractCodeDocumentDM)
	ContractCodeRIDCalc?: TContractCodeDocumentDM
}